import script from "./ContactGroupChip.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactGroupChip.vue?vue&type=script&setup=true&lang=js"

import "./ContactGroupChip.vue?vue&type=style&index=0&id=6975aa57&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6975aa57"]])

export default __exports__